import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CanActivateChildFn } from '@angular/router';
import { AppStore } from '@aaa/emember/store-types';
import { MembershipARActions, MembershipAutoRenewFormStep } from '@aaa/emember/store-membership-auto-renew';

export const setFormStep =
  (activeStep: MembershipAutoRenewFormStep): CanActivateChildFn =>
  () => {
    const store = inject(Store<AppStore>);

    store.dispatch(MembershipARActions.setFormActiveStep({ activeStep }));

    return true;
  };

export default setFormStep;
